/**
 * Service Worker の登録(docs/03_architecture.md §1 / PWA + Workbox)。
 *
 * `vite-plugin-pwa` は `registerType: 'autoUpdate'`(= skipWaiting + clientsClaim)で
 * `sw.js` を生成する。更新の判断はブラウザに任せられるので、`workbox-window` を
 * 足さずに素の `navigator.serviceWorker.register` だけで登録する
 * (バンドルを増やさない / 子ども向けなので更新ダイアログも出さない)。
 */

export function registerServiceWorker(): void {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  // dev サーバーには sw.js が無い(devOptions.enabled = false)。
  if (!import.meta.env.PROD) return;

  const url = `${import.meta.env.BASE_URL}sw.js`;
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register(url, { scope: import.meta.env.BASE_URL }).catch(() => {
      // 登録に失敗してもオンラインなら普通に遊べる。
    });
  });
}
